import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=918ab4ba&scoped=true&lang=pug&"
import script from "./AdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFields.vue?vue&type=style&index=0&id=918ab4ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ab4ba",
  null
  
)

export default component.exports